// Import necessary libraries and components
import React from 'react';
import { Helmet } from 'react-helmet';
import "./landingPage.css";
import FadeInSection from './fadeAnimatedContainer';
import SlideInFromRight from './slideInAnimatedContainer';
import SlideInFromLeft from './slideInLeftAnimatedContainer';
import FadeIn from './fadeAnimatedContainer';
import { Footer } from '../footer/Footer';
import { useSignedInUserState } from '../hooks/useAuthState';

const EcoEatsPage: React.FC = () => {
    const user = useSignedInUserState()

    const userIsOwnerOrStaff = () => {
        if (user.profile && (user.profile.profileType === "owner" || user.profile.profileType == "staff")) {
            return true
        }
        return false
    }

    const userIsSignedOut = () => {
        if (!user.profile) {
            return true
        }
        return false
    }

    return (
        <div className='pat' style={{ fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
            <Helmet>
                <title>Eco Eats | Conscious Choices, Delicious Food</title>
                <meta
                    name="description"
                    content="Eco Eats is a marketplace for delicious, locally-made food that's kinder to the planet. Discover conscious restaurants and eat with purpose."
                />
                <meta
                    name="image"
                    content="./src_assets/drawer_logo.svg"
                />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />


                {/* */}
                <meta property="og:title" content="Eco Eats | Eat with Purpose. Live with Compassion." />
                <meta property="og:description" content="Discover delicious, locally-made food that's better for you and our shared planet. Join a community making conscious choices for a more sustainable world." />
                <meta property="og:image" content="./src_assets/drawer_logo.svg" />

                {/* */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Eco Eats | Eat with Purpose. Live with Compassion." />
                <meta name="twitter:description" content="Discover delicious, locally-made food that's better for you and our shared planet. Join a community making conscious choices for a more sustainable world." />
                <meta name="twitter:image" content="./src_assets/drawer_logo.svg" />
            </Helmet>

            {/* HERO SECTION */}
            <section
                style={{
                    color: '#fff',
                    textAlign: 'center',
                    padding: '6rem 2rem',
                    backgroundImage: " linear-gradient( rgba(245, 249, 233, 1), rgba(245, 249, 233, 0.2) ), url(/landingPageAssets/unsplash-image-bAcMAhWciiM.jpg)",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundColor: ""
                }}
            >
                <section
                    style={{
                        backgroundColor: "rgba(255, 255, 255, 0.85)",
                        padding: "2rem",
                        borderRadius: "15px",
                        display: "inline-block",
                        maxWidth: "700px",
                        margin: "0 auto"
                    }}
                >
                    <FadeInSection>
                        <h1
                            style={{
                                color: '#162C1F',
                                fontSize: '60px',
                                fontWeight: '700',
                                marginBottom: '1rem',
                            }}
                        >
                            Eat with Purpose. Live with Compassion.
                        </h1>
                    </FadeInSection>

                    <FadeInSection>
                        <p className="LatoText" style={{ color: '#162C1F', fontSize: '20px', maxWidth: '600px', margin: '0 auto 2rem' }}>
                            Eco Eats is a space for delicious food and conscious choices. We feature curated meals from local restaurants that are better for you and our shared planet. It’s about a love for all of existence and making choices that nourish our world. Discover food that’s great for the palate and the planet.
                        </p>
                    </FadeInSection>

                    <FadeInSection>
                        {
                            (user.profile && user.profile.profileType === "admin") ?
                                <a
                                    style={{
                                        backgroundColor: '#162C1F',
                                        border: 'none',
                                        color: '#fff',
                                        padding: '0.75rem 2rem',
                                        cursor: 'pointer',
                                        borderRadius: '25px',
                                        fontSize: '18px',
                                        fontWeight: '500',
                                        textDecoration: 'none'
                                    }}
                                    href="/adminPortal"
                                >
                                    Admin Dashboard
                                </a>
                                :
                                userIsOwnerOrStaff() ?
                                    <a
                                        style={{
                                            backgroundColor: '#162C1F',
                                            border: 'none',
                                            color: '#fff',
                                            padding: '0.75rem 2rem',
                                            cursor: 'pointer',
                                            borderRadius: '25px',
                                            fontSize: '18px',
                                            fontWeight: '500',
                                            textDecoration: 'none'
                                        }}
                                        href="/dashboard"
                                    >
                                        Dashboard
                                    </a>
                                    :
                                    <a
                                        style={{
                                            backgroundColor: '#162C1F',
                                            border: 'none',
                                            color: '#fff',
                                            padding: '0.75rem 2rem',
                                            cursor: 'pointer',
                                            borderRadius: '25px',
                                            fontSize: '18px',
                                            fontWeight: '500',
                                            textDecoration: 'none'
                                        }}
                                        href={userIsSignedOut() ? "/login" : "/search"}
                                    >
                                        Browse Deals
                                    </a>
                        }
                    </FadeInSection>
                </section>
            </section>

            {/* ABOUT SECTION */}
            <section
                style={{
                    padding: '5rem 2rem',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: '2rem',
                        justifyContent: 'center',
                        textAlign: 'left'
                    }}
                >
                    <div style={{ flex: 1, minWidth: '300px', maxWidth: '700px', textAlign: 'center' }}>
                        <FadeIn>
                            <h2 className="MontserratText">Great Food in Three Simple Steps</h2>
                            <p className="LatoText" style={{ textAlign: 'center', margin: '0 auto', maxWidth: '550px' }}>
                                Ready for something amazing? With Eco Eats, you're just three steps from a delicious, planet-friendly meal. <strong>1. Discover:</strong> Explore menus from top-rated local plant-based eateries. <strong>2. Order:</strong> Securely place your order through our platform. <strong>3. Collect:</strong> Pick up your fresh meal directly from the restaurant. Good food has never been this easy.
                            </p>
                        </FadeIn>
                    </div>

                    <SlideInFromRight>
                        <div style={{ flex: 1, minWidth: '300px', maxWidth: '700px' }}>
                            <img
                                src="/landingPageAssets/unsplash-image-6WrKKQcEnXk.jpg"
                                alt="How Eco Eats works"
                                style={{
                                    width: '100%',
                                    maxWidth: '600px',
                                    margin: '2rem auto',
                                    display: 'block',
                                    borderRadius: '15px',
                                }}
                            />
                        </div>
                    </SlideInFromRight>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: '2rem',
                        justifyContent: 'center',
                        textAlign: 'left'
                    }}
                >
                    <SlideInFromLeft>
                        <div style={{ flex: 1, minWidth: '300px', maxWidth: '700px' }}>
                            <img
                                src="/landingPageAssets/unsplash-image-urcDzLL0HnI.jpg"
                                alt="Eco Eats community impact"
                                style={{
                                    width: '100%',
                                    maxWidth: '600px',
                                    margin: '2rem auto',
                                    display: 'block',
                                    borderRadius: '15px',
                                }}
                            />
                        </div>
                    </SlideInFromLeft>

                    <div style={{ flex: 1, minWidth: '300px', maxWidth: '700px', textAlign: 'center' }}>
                        <FadeIn>
                            <h2 className="MontserratText">More Than a Meal—It's a Movement.</h2>
                            <p className="LatoText">
                                Eco Eats is for everyone who wants to be a custodian of our shared home. We believe that choosing food with compassion and intention can create a ripple effect of positive change. Every order supports local, eco-conscious businesses, helps conserve our planet's precious resources, and moves us all toward a more sustainable future. This is about choosing love for all of existence, one plate at a time.
                            </p>
                        </FadeIn>
                    </div>
                </div>

                {/* PARTNERS SECTION */}
                <section className="partners-section">
                    <h2 className="MontserratText">Our Partners</h2>
                    <div className="partners-container">
                        <a href="https://plantbasedtreaty.org/" target="_blank" rel="noopener noreferrer" className="partner-card-link">
                            <div className="partner-card">
                                <img src="/landingPageAssets/PlantBasedTreaty.jpeg" alt="Plant Based Treaty Logo" className="partner-logo" />
                                <h3 className="partner-name">Plant Based Treaty</h3>
                                <p className="LatoText partner-description">
                                    An initiative to put food systems at the forefront of combating the climate crisis by promoting a shift to healthy, sustainable plant-based diets.
                                </p>
                            </div>
                        </a>
                        <a href="https://sentineloceanalliance.org/" target="_blank" rel="noopener noreferrer" className="partner-card-link">
                            <div className="partner-card">
                                <img src="/landingPageAssets/SentinelOceanAlliance.jpg" alt="Sentinel Ocean Alliance Logo" className="partner-logo" />
                                <h3 className="partner-name">Sentinel Ocean Alliance</h3>
                                <p className="LatoText partner-description">
                                    Creating ocean-based opportunities and environmental education for the youth of South Africa's coastal communities, including our beach clean-up collaborations.
                                </p>
                            </div>
                        </a>
                    </div>
                </section>

                {/* Optional Contact CTA */}

                <h2 className="MontserratText">Important Links</h2>

                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: '2rem',
                        justifyContent: 'center',
                        textAlign: 'center',
                        width: '100%',
                        flexDirection: 'row'
                    }}
                >

                    <a
                        style={{
                            backgroundColor: 'transparent',
                            border: '1px solid #162C1F',
                            color: '#162C1F',
                            padding: '0.75rem 2rem',
                            cursor: 'pointer',
                            borderRadius: '25px',
                            fontSize: '18px',
                            fontWeight: '400',
                            textDecoration: 'none',
                            minWidth: 100,
                        }}
                        href="/about"
                    >
                        About Us
                    </a>

                    <a
                        style={{
                            backgroundColor: 'transparent',
                            border: '1px solid #162C1F',
                            color: '#162C1F',
                            padding: '0.75rem 2rem',
                            cursor: 'pointer',
                            borderRadius: '25px',
                            fontSize: '18px',
                            fontWeight: '400',
                            textDecoration: 'none',
                            minWidth: 100,
                        }}
                        href="/faq"
                    >
                        FAQ
                    </a>

                    <a
                        style={{
                            backgroundColor: 'transparent',
                            border: '1px solid #162C1F',
                            color: '#162C1F',
                            padding: '0.75rem 2rem',
                            cursor: 'pointer',
                            borderRadius: '25px',
                            fontSize: '18px',
                            fontWeight: '400',
                            textDecoration: 'none',
                            minWidth: 100,
                        }}
                        href="https://chat.whatsapp.com/IVOn0fM2cJIKojlLvNYjc0"
                    >
                        Join on WhatsApp
                    </a>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default EcoEatsPage;
